/* Bilingual page toggle (EN/ES).
   The INITIAL language is set at parse time by the inline script in
   snippets/bilingual-base.liquid (body[data-lang]); this file wires up the
   toggle buttons and keeps every <lang-toggle> instance in sync.
   Content blocks are marked data-lang-block="en|es"; visibility is CSS-driven
   off body[data-lang], so with JS disabled the page shows English. */
(function () {
  var KEY = 'utz-lang';

  function currentLang() {
    // body[data-lang] is authoritative: it survives section re-renders and
    // URL rewrites (e.g. the theme's variant-change replaceState drops ?lang=).
    var cur = document.body && document.body.getAttribute('data-lang');
    if (cur === 'es' || cur === 'en') return cur;
    try {
      var p = new URLSearchParams(location.search).get('lang');
      if (p === 'es' || p === 'en') return p;
      var saved = localStorage.getItem(KEY);
      if (saved === 'es' || saved === 'en') return saved;
    } catch (e) { /* storage blocked */ }
    return (navigator.language || '').toLowerCase().indexOf('es') === 0 ? 'es' : 'en';
  }

  function syncButtons(root, lang) {
    (root || document).querySelectorAll('lang-toggle button[data-lang]').forEach(function (btn) {
      var active = btn.getAttribute('data-lang') === lang;
      btn.classList.toggle('lang-toggle__btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function setLang(lang, updateUrl) {
    document.body.setAttribute('data-lang', lang);
    try { localStorage.setItem(KEY, lang); } catch (e) {}
    if (updateUrl) {
      try {
        var url = new URL(location.href);
        url.searchParams.set('lang', lang);
        history.replaceState(null, '', url);
      } catch (e) {}
    }
    syncButtons(document, lang);
    document.dispatchEvent(new CustomEvent('lang:change', { detail: { lang: lang } }));
  }

  if (!customElements.get('lang-toggle')) {
    customElements.define('lang-toggle', class extends HTMLElement {
      connectedCallback() {
        // Elements can reconnect when the theme swaps section HTML —
        // guard the listener and re-sync buttons to the live language.
        if (!this.__wired) {
          this.__wired = true;
          this.addEventListener('click', function (e) {
            var btn = e.target.closest('button[data-lang]');
            if (btn) setLang(btn.getAttribute('data-lang'), true);
          });
        }
        syncButtons(this, currentLang());
      }
    });
  }

  function boot() { setLang(currentLang(), false); }
  if (document.body) { boot(); } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
